import { create } from 'zustand';

export const useConfirmationStore = create(set => ({
    open: false,
    loading: false,

    // Kept after closing so the dialog keeps its content during the leave
    // transition; the next confirm() call replaces them wholesale.
    options: {},

    confirm: options => set({ open: true, loading: false, options }),
    setLoading: loading => set({ loading }),
    close: () => set({ open: false, loading: false }),
}));
